import React, { useState } from 'react';
import axios from 'axios';
import '../Steelcity/css/Flyingman.css'
import Logo from '../Logo/Flyingmanlogo.png';
import Swal from 'sweetalert2';

const Flyingman = () => {
    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState<any[]>([]);
    const [currentStep, setCurrentStep] = useState(1);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };

    const statusToStep: { [key: string]: number } = {
        'Booked': 1,
        'InTransit': 2,
        'DELIVERED': 3,
        'Delivered': 4,
    };

    const handleButtonClick = () => {
        setShowImage(!showImage);
    };

    const fetchData = async () => {
        try {
            const trimmedInputs = searchValue
                .split(',')
                .map((item) => item.trim())
                .filter((item) => item.length > 0);

            if (trimmedInputs.length === 0) {
                setError('Please enter one or more tracking numbers separated by commas.');
                return;
            }

            const awbNumbers = trimmedInputs.filter((item) => /^\d+$/.test(item));
            const refNumbers = trimmedInputs.filter((item) => /\D/.test(item));

            let queryParams: { awbNo?: string; refNo?: string } = {};

            if (awbNumbers.length > 0) {
                queryParams.awbNo = awbNumbers.join(',');
            }
            if (refNumbers.length > 0) {
                queryParams.refNo = refNumbers.join(',');
            }

            const res = await axios.get('https://trackerex.com/TrackingDabhlogisticApi/TrackingData', {
                params: queryParams,
            });

            const data = res.data;

            console.log(data, 'arjun ');


            if (data?.status === 1 && Array.isArray(data.data)) {
                const tryImageExtensions = async (awbNo: string): Promise<string | null> => {
                    const extensions = ['jpg', 'jpeg', 'png'];
                    for (const ext of extensions) {
                        const url = `https://trackerex.com/PODImg/${awbNo}.${ext}`;
                        const exists = await checkImageExists(url);
                        if (exists) return url;
                    }
                    return null;
                };

                const checkImageExists = (url: string): Promise<boolean> => {
                    return new Promise((resolve) => {
                        const img = new Image();
                        img.src = url;
                        img.onload = () => resolve(true);
                        img.onerror = () => resolve(false);
                    });
                };

                const fetchImageLinks = async () => {
                    const updatedData = await Promise.all(data.data.map(async (item: any) => {
                        const imageUrl = await tryImageExtensions(item.awbNo);
                        return {
                            ...item,
                            ImageLink: imageUrl, // null if no image found
                        };
                    }));

                    setTrackingData(updatedData);
                    setError('');
                    setSearchValue('');

                    if (updatedData.length > 0) {
                        const status = updatedData[0].Status;
                        setCurrentStep(statusToStep[status] || 1);
                    }
                };

                fetchImageLinks();
            } else {
                setTrackingData([]);
                Swal.fire({
                    icon: 'warning',
                    title: 'Docket Not Found',
                    text: 'The entered docket number was not found.',
                });
            }
        } catch (error: any) {
            console.error('Error:', error);
            setTrackingData([]);
            setError(
                error.response?.data?.message ||
                'Failed to fetch data. Please check your internet connection.'
            );
        }
    };

    return (
        <>


            <div className="custom-blue-bar text-white">
                <div className="container text-center text-lg-end py-2 fw-semibold">
                    flyingman001@outlook.com |📞 +022 2267 0044
                </div>
            </div>

            <div className="container-floud py-1">
                <div className="row align-items-center">
                    <div className="col-12 col-lg-3 text-center text-lg-start mb-3 mb-lg-0">
                        <img
                            src={Logo}
                            alt="Company Logo"
                            className="img-fluid"
                            style={{ width: '150px', height: '100px', marginLeft: "20px" }}  // Customize as needed
                        />
                    </div>

                    <div className="col-12 col-lg-9">
                        <nav className="navbar navbar-expand-lg custom-navbar">
                            <div className="container-fluid p-0">
                                {/* <a className="navbar-brand" href="#">Flying Man Courier</a> */}
                                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                                    <ul className="navbar-nav ms-auto">
                                        <li className="nav-item"><a className="nav-link" href="https://flyingmancourier.com">Home</a></li>
                                        <li className="nav-item"><a className="nav-link" href="https://trackerex.com/FlyingManTracking/">Tracking</a></li>
                                        <li className="nav-item"><a className="nav-link" href="https://flyingmancourier.com/about-us">About</a></li>
                                        <li className="nav-item"><a className="nav-link" href="https://flyingmancourier.com/services/">Services</a></li>
                                        <li className="nav-item"><a className="nav-link" href="https://flyingmancourier.com/contact-us/">Contact Us</a></li>
                                    </ul>
                                </div>
                            </div>
                        </nav>

                    </div>

                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="shadow p-4">
                            <input
                                type="text"
                                placeholder="Tracking Number(s)"
                                className="form-control mb-2 text-center border border-info"
                                value={searchValue}
                                onChange={handleInputChange}
                            />
                            <button onClick={fetchData} className="Track1 w-100">TRACK HERE</button>
                            {error && <div className="text-danger mt-2">{error}</div>}
                            <p className="mt-2">To track multiple AwbNo</p>
                        </div>
                    </div>
                </div>
            </div>





            <div className="container">
                <div className="row">
                    <div className="col-lg-9">
                        {trackingData.map((record, index) => (
                            <div key={index} className="shadow p-4 mb-4">
                                <h5 className="mb-3 text-center">Tracking Details</h5>
                                <table className="table table-bordered table-sm mb-4">
                                    <thead>
                                        <tr>
                                            <th>AwbNo</th>
                                            <th>Ref_No</th>
                                            <th>BookDate</th>
                                            <th>Consignee_Name</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{record.awbNo}</td>
                                            <td>{record.refNo || '-'}</td>
                                            <td>{record.bookDate}</td>
                                            <td>{record.consigneeName}</td>
                                            <td>{record.Status}</td>
                                        </tr>
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th>Qty</th>
                                            <th>Destination</th>
                                            <th>Receiver Name</th>
                                            <th>Delivery Date</th>
                                            <th>Delivery Time</th>
                                            {/* <th>Contact_No</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{record.Qty}</td>
                                            <td>{record.destinationName}</td>
                                            <td>{record.recvName}</td>
                                            <td>{record.DelvDT}</td>
                                            <td>{record.DelvTime}</td>
                                            {/* <td>{record.Destination_PIN}</td> */}
                                        </tr>

                                        <tr>
                                            <th>Mobile_No</th>
                                            <td>{record.Destination_PIN}</td>
                                            <td colSpan={5}>
                                                <button className="btn btn-success" onClick={handleButtonClick}>
                                                    {showImage ? 'Hide Image' : 'Pod Image'}
                                                </button>
                                                {showImage && (
                                                    <div className="image-container mt-2 text-center">
                                                        <img src={record.ImageLink} alt="Podimages" className="img-fluid" />
                                                    </div>
                                                )}
                                            </td>

                                        </tr>
                                        <tr>

                                        </tr>


                                    </tbody>
                                </table>



                                <div className="w-100 position-relative" style={{ paddingBottom: '30px' }}>
                                    {/* Background Progress Line */}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '15px',
                                            left: 0,
                                            right: 0,
                                            height: '4px',
                                            backgroundColor: '#ccc',
                                            zIndex: 0,
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${((currentStep - 1) / 2) * 100}%`, // since 3 steps → 2 gaps
                                                height: '100%',
                                                backgroundColor: '#007bff',
                                                transition: 'width 0.3s ease',
                                            }}
                                        ></div>
                                    </div>

                                    {/* Step Circles and Labels */}
                                    <div className="steps-container d-flex justify-content-between align-items-center my-3" style={{ position: 'relative', zIndex: 1 }}>
                                        {['Booked', 'InTransit', 'DELIVERED'].map((stepLabel, index) => {
                                            const normalizedLabel = stepLabel.toLowerCase();
                                            const stepNum = index + 1;
                                            const isActive = stepNum <= currentStep;

                                            return (
                                                <div key={normalizedLabel} className="text-center" style={{ flex: 1 }}>
                                                    <div
                                                        className={`step-circle ${isActive ? 'active' : ''}`}
                                                        style={{
                                                            width: '30px',
                                                            height: '30px',
                                                            borderRadius: '50%',
                                                            backgroundColor: isActive ? '#007bff' : '#ccc',
                                                            color: 'white',
                                                            lineHeight: '30px',
                                                            margin: '0 auto',
                                                            fontWeight: 'bold',
                                                        }}
                                                    >
                                                        {stepNum}
                                                    </div>
                                                    <div className="step-label mt-2">
                                                        {normalizedLabel.charAt(0).toUpperCase() + normalizedLabel.slice(1)}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>


                            </div>
                        ))}

                        {trackingData.map((record, index) => (
                            <div key={index} className="shadow p-4 mb-4">
                                <h5 className="mb-3 text-center"> Status Tracking </h5>
                                <table className="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            <th>AwbNo</th>
                                            <th>Status_Date</th>
                                            <th>Status_Time</th>
                                            <th>Location_Update</th>
                                            <th>Activity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {record.podHistory?.map((history: any, idx: number) => (
                                            <tr key={idx}>
                                                <td>{history.Awbno}</td>
                                                <td>{history.DelvDt}</td>
                                                <td>{history.DelvTime}</td>
                                                <td>{history.Destination_Name}</td>
                                                <td>{history.Remark}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <footer>
                <div className="row footerflyingman text-black">
                    <div className="col-md-3">
                          <img
                            src={Logo}
                            alt="Company Logo"
                            className="img-fluid"
                            style={{ width: '150px', height: '100px', marginLeft: "20px" }}  // Customize as needed
                        />
                       <h3><strong className="white-text">Fast, Secure, and Hassle-Free Courier Services.</strong></h3>

                        
                    </div>

                    <div className="col-md-3">
                        <h3><strong className="link">SERVICES</strong></h3>
                       <ul className="list-unstyled">
                            <li><a href="http://dabhlogistics.com/about%20us.html">Profile</a></li>
                            <li><a href="http://dabhlogistics.com/services.html">Services</a></li>
                            <li><a href="http://dabhlogistics.com/document.html">Document</a></li>
                            <li><a href="http://dabhlogistics.com/contact%20us.html">Contact Us</a></li>
                        </ul>
                    </div>

                    <div className="col-md-3">
                        <h3><strong className="link">CALL US</strong></h3>
                        <p>
                            <a href="get-quote.html">
                                DABH LOGISTICS PVT LTD<br />
                                45/1, Margarate House<br />
                                Dewalwadi, JB Nagar<br />
                                Andheri (E), Mumbai-400099<br />
                                Tel: 02228250906 / 07
                            </a>
                        </p>
                    </div>

                    <div className="col-md-3">
                        <h3><strong className="link">CONTACT DETAILS</strong></h3>
                        <p>
                            Office No 8, Hira Building,<br />
                            17/19 Mint Road, Fort, Mumbai - 400001<br />
                            +022 22267 0044<br />
                            info@flyingmancourier.com
                        </p>

                        <h4><strong className="link">CONNECT US</strong></h4>
                        <img src="images/facebook.png" alt="Facebook" style={{ width: '24px' }} />&nbsp;&nbsp;
                        <img src="images/youtube.png" alt="YouTube" style={{ width: '24px' }} />
                    </div>
                </div>

                <br />
            </footer>

        </>
    );
};

export default Flyingman;

